import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthService,useContextService } from '../../services';
import { SessionKey } from "../../utils/app-config";


function AuthCallbackCP() {
  let [searchParams] = useSearchParams();
  const {getCPToken} = useAuthService(); 
  const { putContextUser} = useContextService();

  useEffect(()=>{
    var code=searchParams.get("code");
    var state=searchParams.get("state");
    const fetchData=async()=>{
        let token = await getCPToken(code,state); 
        
        if(token.user){
          await putContextUser(token.user);
          localStorage.setItem(SessionKey.AuthToken, token.jwt);
          window.location.href = '/eservices/';
        }
        
  }
  fetchData(); 
},[])


  return (
    <div>
      <div>Redirecting.........</div>
    </div>
  );
}

export default AuthCallbackCP;
